/* Shared color palette, static reference data, and lookup tables used across the Sales Dashboard. */

export const COLORS = {
  bg: "#F6F8FC",
  card: "#FFFFFF",
  border: "#E7EBF3",
  heading: "#0F172A",
  text: "#3B4457",
  muted: "#8896A8",
  primary: "#4F46E5",
  primarySoft: "#EEF2FF",
  primaryGradA: "#4F46E5",
  primaryGradB: "#8B7CF6",
  success: "#16A34A",
  successSoft: "#ECFDF3",
  warning: "#F59E0B",
  warningSoft: "#FFFBEB",
  danger: "#EF4444",
  dangerSoft: "#FEF2F2",
  info: "#0EA5E9",
  infoSoft: "#EFF8FF",
  purple: "#8B5CF6",
  purpleSoft: "#F5F3FF",
  teal: "#0D9488",
  tealSoft: "#F0FDFA",
  pink: "#EC4899",
  pinkSoft: "#FDF2F8",
};

export const SOURCE_COLORS = [
  COLORS.primary,
  COLORS.success,
  COLORS.warning,
  COLORS.info,
  COLORS.teal,
];
export const RANGES = [
  "Today",
  "This Week",
  "This Month",
  "This Quarter",
  "This Year",
];
/* Range options for cards that only care about Month/Quarter/Year */
export const TABLE_RANGES = ["This Month", "This Quarter", "This Year"];

export const RANGE_SCALE = {
  Today: 0.045,
  "This Week": 0.22,
  "This Month": 1,
  "This Quarter": 3.1,
  "This Year": 12,
};
/* Deterministic pseudo-random so numbers don't jitter on every re-render */

/* ---------- Monthly Target (radial) ---------- */
export const MONTHLY_TARGET = {
  target: 450000,
  achieved: 369000,
  remaining: 81000,
  pct: 82,
};

export const WIN_RATE = { value: 62, prevValue: 57 };

export const STATUS_STYLE = {
  Won: { color: COLORS.success, soft: COLORS.successSoft },
  "In Progress": { color: COLORS.info, soft: COLORS.infoSoft },
  Negotiation: { color: COLORS.primary, soft: COLORS.primarySoft },
  Proposal: { color: COLORS.warning, soft: COLORS.warningSoft },
  Lost: { color: COLORS.danger, soft: COLORS.dangerSoft },
  Qualified: { color: COLORS.teal, soft: COLORS.tealSoft },
};

/* ---------- Sales Funnel stage metadata ---------- */
export const FUNNEL_STAGE_META = {
  leads: { label: "Leads", fill: COLORS.info },
  deals: { label: "Deals", fill: COLORS.purple },
  quotation: { label: "Quotation", fill: COLORS.warning },
  sales_order: { label: "Sales Order", fill: COLORS.primary },
  invoice: { label: "Invoice", fill: COLORS.success },
};


export const FUNNEL_WIDTH_STEPS = ["100%", "85%", "75%", "65%", "55%"];

/* ---------- Pipeline Distribution stage color palette ---------- */
export const STAGE_COLOR_PALETTE = [
  COLORS.info,
  COLORS.purple,
  COLORS.warning,
  COLORS.primary,
  COLORS.success,
  COLORS.danger,
  COLORS.teal,
  COLORS.pink,
];

/* ---------- Owner avatar color palette (Hot Leads / Recent Deals tables) ---------- */
export const OWNER_COLORS = [
  "#4F46E5",
  "#0EA5E9",
  "#8B5CF6",
  "#16A34A",
  "#F59E0B",
  "#EC4899",
];
